import React from 'react';

interface UseResponsiveCloudinaryImageResult {
  src: string;
  srcSet: string;
}

const generateCloudinaryUrl = (baseUrl: string, dpr: number): string => {
  return baseUrl.replace('dpr_auto', `dpr_${dpr.toFixed(1)}`);
};

export const useResponsiveCloudinaryImage = (
  baseSrc: string
): UseResponsiveCloudinaryImageResult => {
  return React.useMemo(() => {
    const trimmedSrc = baseSrc?.trim();
    if (!trimmedSrc) {
      return { src: '', srcSet: '' };
    }

    const url1x = generateCloudinaryUrl(trimmedSrc, 1);
    const url2x = generateCloudinaryUrl(trimmedSrc, 2);
    const url3x = generateCloudinaryUrl(trimmedSrc, 3);
    const srcSetValue = `${url1x} 1x, ${url2x} 2x, ${url3x} 3x`;

    return {
      src: url1x,
      srcSet: srcSetValue,
    };
  }, [baseSrc]);
};
